import { Component, Inject, forwardRef } from "@angular/core";
import { NavigationService } from "../../../service/navigation.service";
import { WorkOrderLinkTableColumn } from "../custom-table-column/work-order-link-table-column";
import { ClickableTableValueComponent } from "./clickable-table-value.component";

@Component({
    selector: 'work-order-link-table-value',
    template: '<span class="highlight" (click)="click($event)">{{this.element?.workOrder?.code}}</span>'
})
export class WorkOrderLinkTableValueComponent extends ClickableTableValueComponent<WorkOrderLinkTableColumn> {

    constructor(
        @Inject(forwardRef(() => NavigationService)) protected navigationService: NavigationService
    ) { super(navigationService) }

    click($event: any): void {
        $event.stopPropagation();
        this.buttonAction.emit({ action: 'openWorkOrder', value: this.element?.workOrder, index: this.rowIndex });
    }

}